import React from 'react';

import SessaoDigitacaoBase from '../../components/Digitacao/SessaoDigitacaoBase';
import { MODOS_SESSAO } from '../../components/Digitacao/PainelSessaoDigitacao';

const SessaoDigitar = () => <SessaoDigitacaoBase mode={MODOS_SESSAO.DIGITAR} />;

export default SessaoDigitar;
